import script from "./AllmodulesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AllmodulesComponent.vue?vue&type=script&setup=true&lang=js"

import "./AllmodulesComponent.vue?vue&type=style&index=0&id=b69a2582&lang=css"

const __exports__ = script;

export default __exports__